import store from '../store';
import axios from 'axios';
axios.defaults.baseURL = BangeoHost;

export default {
	saveUser: async (wait) => {
		console.info("COGNITO_saveUser");
		console.time("COGNITO_saveUser");

		const user = store.state.user.user;

		if (user) {
			let userData = {
				cid: user.username,
				email: user.email
			};
			if (user.given_name) userData.first_name = user.given_name;
			if (user.family_name) userData.last_name = user.family_name;
			if (user.birthdate) userData.dob = user.birthdate;
			if (localStorage.ffaUserRego) {
				let ffaUserRego = JSON.parse(localStorage.ffaUserRego);
				userData = {...userData, ...ffaUserRego};
				localStorage.removeItem('ffaUserRego');
			}
			if (wait) {
				await axios.post('/api/v1/bangeo/save', userData).then(result => {
					return result;
				}).catch(error => {
					return error;
				});
			} else {
				axios.post('/api/v1/bangeo/save', userData).then(result => {
					return result;
				}).catch(error => {
					// console.log("saveUser error", error);
					return error;
				});
			}
			axios.post('/api/v1/bangeo/save', userData).then(result => {
				return result;
			}).catch(error => {
				return error;
			});
		} else {
			return false;
		}
	},
	getOffersByUser: () => {
		console.info("COGNITO_getOffersByUser");
		console.time("COGNITO_getOffersByUser");

		const user = store.state.user.user;

		if (user) {
			let userData = {
				cid: user.username
			};
			if (localStorage.ffaUserRego) {
				let ffaUserRego = JSON.parse(localStorage.ffaUserRego);
				userData = {...userData, ...ffaUserRego};
			}
			return axios.post('/api/v1/bangeo/offers', userData);
		} else {
			return false;
		}
	},
	saveUserOffers: (offers) => {
		console.info("COGNITO_saveUserOffers");
		console.time("COGNITO_saveUserOffers");

		const user = store.state.user.user;

		if (user) {
			let userOffersData = {
				cid: user.username,
				offers: offers
			};
			return axios.post('/api/v1/bangeo/user-offers', userOffersData);
		} else {
			return false;
		}
	},
	getUser: (user) => {
		console.info("COGNITO_getUser");
		console.time("COGNITO_getUser");

		if (!user) {
			user = store.state.user.user;
		}

		if (user) {
			let userData = {
				cid: user.username
			};
			return axios.post('/api/v1/bangeo/user', userData);
		} else {
			return false;
		}
	},
	getDtaConfig: () => {
		console.info("COGNITO_getDtaConfig");
		console.time("COGNITO_getDtaConfig");

		return axios.get('/api/v1/bangeo/regoconfig');
	}
}
